export default __webpack_public_path__ + "static/media/indoor-3.3104f06e.png";